module.exports = __webpack_public_path__ + "img/security-check-icon.2cbfe73a.svg";